<template>
	<div class="container">
		<el-row style="height: 100%;position: relative;">
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="left_container full">
						<div class="title flex">字段列表</div>
						<div class="list" style="height: 360px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;" @click="clearformitem">
								<div @click="formitemItemClick(item,index,$event)" @dblclick="toRight" class="formitem"
									:class="{formitem_active:item.active}" v-for="(item,index) in formitem"
									:key="index">
									{{item.name}}
								</div>
							</div>
						</div>
						<div class="title flex">相对位置</div>
						<div class="list" style="height: 150px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;font-size: 14px;" @click="clearRelativep"
								v-if="itemtype=='department'">
								<div @click="relativepItemClick(item,index,$event)" class="relativep"
									:class="{relativep_active:item.active}" v-for="(item,index) in relativeP"
									:key="index">{{item.label}}</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="4" style="height: 100%;position: relative;">
				<div class="middle flex">
					<div>
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-right" circle
							@click="toRight"></el-button>
					</div>
					<div style="margin-top: 50px;">
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-left" circle
							@click="toLeft"></el-button>
					</div>
				</div>
			</el-col>
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="right_container full">
						<div class="title flex">授权列表</div>
						<div class="list" style="height: 550px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;" @dblclick="toLeft"  @click="clearDataItem">
								<div @click="dataItemClick(item,index,$event)" class="data"
									:class="{data_active:item.active}" v-for="(item,index) in data" :key="index">
									{{item.name}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>

</template>
<style scoped>
	.container {
		position: relative;
		width: 100%;
		height: 600px;
	}

	.middle {
		height: 100%;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.left_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.right_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.title {
		position: relative;
		width: 100%;
		height: 40px;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 18px;

		background: rgb(244, 244, 245);
		border-bottom: 1px solid #d7dae2;
	}

	.list {
		position: relative;
		width: 100%;
		height: 410px;
		overflow: auto;
	}

	.formitem {
		font-size: 14px;
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
	}

	.formitem_active {
		background-color: #409EFF;
		color: white;
	}

	.relativep {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
	}

	.relativep_active {
		background-color: #409EFF;
		color: white;
	}

	.data {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
		font-size: 14px;
	}

	.data_active {
		background-color: #409EFF;
		color: white;
	}
</style>
<script>
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			formid: {
				type: Number,
				default: () => {
					return 0
				}
			},
			type: {
				default: () => {
					return ['staff','department']
				}
			}
		},
		data() {
			return {
				formitemloading: false,
				currentformitem: null,
				sourceformitem: [],
				formitem: [],
				data: [],
				itemtype: '',
				relativeP: [{
						label: '当前部门所有人',
						type: 'self',
						active: false
					},
					{
						label: '当前部门管理员',
						type: 'self_manager',
						active: false
					},
					{
						label: '下级部门所有人',
						type: 'children_only',
						active: false
					},
					{
						label: '下级部门管理员',
						type: 'children_manager_only',
						active: false
					},
					{
						label: '上级部门所有人',
						type: 'parent_only',
						active: false
					},
					{
						label: '上级部门管理员',
						type: 'parent_manager_only',
						active: false
					},
					{
						label: '及其下级部门所有人',
						type: 'children',
						active: false
					},
					{
						label: '及其下级部门管理员',
						type: 'children_manager',
						active: false
					},
					{
						label: '及其上级部门所有人',
						type: 'parent',
						active: false
					},
					{
						label: '及其上级部门管理员',
						type: 'parent_manager',
						active: false
					},
				]
			}

		},
		watch: {

		},
		computed: {

		},
		created() {
			this.listformitem()
		},
		mounted() {

		},
		methods: {
			listformitem() {
				this.$api.form.get(this.formid).then((res) => {
					let rule = res.rule.rule
					let pattern = /(?:staffid|departmentid)$/
					if( this.type.includes('staff') && this.type.includes('department') ){
						pattern = /(?:staffid|departmentid)$/
					}else if(this.type.includes('staff')){
						pattern = /(?:staffid)$/
					}else{
						pattern = /(?:departmentid)$/
					}
					rule.forEach((item) => {
						if (item.field && pattern.test(item.field)) {
							this.sourceformitem.push({
								id: item.field,
								name: item.title
							})
						}
					})
					this.createformitem(this.sourceformitem)
				})
				// this.$api.formitem.list({
				// 	currentPage: -1
				// }).then((res) => {
				// 	this.sourceformitem = res.list
				// 	this.createformitem(res.list)
				// })
				// this.sourceformitem = [
				// 	{id:1,name:'发起人'},
				// 	{id:2,name:'发起人部门管理员'},
				// 	{id:3,name:'发起人师傅'}
				// ]

			},
			relativepItemClick(item, index, e) {
				e.stopPropagation()
				this.clearRelativep()
				this.relativeP[index].active = true
			},
			clearRelativep() {
				this.relativeP.forEach((item) => {
					item.active = false
				})
			},
			getActiveRelativep() {
				let obj = null
				this.relativeP.forEach((item) => {
					if (item.active) {
						obj = item
					}
				})
				return obj
			},
			createformitem(list) {
				let arr = []
				list.forEach((item) => {
					arr.push({
						id: item.id,
						name: item.name,
						active: false
					})
				})
				this.formitem = arr
			},
			formitemItemClick(item, index, e) {
				e.stopPropagation()
				this.clearformitem()
				this.formitem[index].active = true
				this.currentformitem = item
				let isdepartment = /(?:departmentid)$/
				if (isdepartment.test(item.id)) {
					this.itemtype = 'department'
				} else {
					this.itemtype = 'staff'
				}
			},
			clearformitem() {
				this.formitem.forEach((item) => {
					item.active = false
				})
			},
			dataItemClick(item, index, e) {
				e.stopPropagation()
				this.clearDataItem()
				this.data[index].active = true

			},
			clearDataItem() {
				this.data.forEach((item) => {
					item.active = false
				})
			},
			getActiveDataItem() {
				let obj = null
				this.data.forEach((item, index) => {
					if (item.active) {
						obj = {
							item: item,
							index: index
						}
					}
				})
				return obj
			},
			checkDataItemUnique(checkItem) {
				let obj = null
				this.data.forEach((item) => {
					if (item.id == checkItem.id) {
						obj = true
					}
				})
				return obj
			},
			toRight() {
				let relativep = this.getActiveRelativep()
				let obj = null
				if (!this.currentformitem) {
					this.$message.error({
						message: '请选择字段',
					})
				} else {
					if (this.itemtype == 'staff') {
						obj = {
							id: this.currentformitem.id,
							name: this.currentformitem.name,
							active: false,
						}
					} else if (!relativep) {
						this.$message.error({
							message: '请选择相对位置',
						})
						return
					} else {
						obj = {
							id:this.currentformitem.id,
							name: this.currentformitem.name + '（' + relativep.label + '）',
							departmentid: this.currentformitem.id,
							departmentname: this.currentformitem.name,
							typename: relativep.label,
							type: relativep.type,
							active: false,
						}
					}
					if (!this.checkDataItemUnique(obj)) {
						this.data.push(obj)
						this.dataChange()
					} else {
						this.$message.error({
							message: '该选项已存在',
						})
					}


				}
			},
			toLeft() {
				let obj = this.getActiveDataItem()
				if (obj) {
					this.data.splice(obj.index, 1)
					this.dataChange()
				}
			},
			submitData() {
				return this.data
			},
			setData(data) {
				data.forEach((item) => {
					item.active = false
				})
				this.data = data
			},
			dataChange() {
				this.$emit('datachange', {
					data: this.data,
					type: 'formitem'
				})
			}
		},
		components: {

		}
	}
</script>
